import { render, staticRenderFns } from "./TabsD.vue?vue&type=template&id=be951680&lang=pug"
import script from "./TabsD.vue?vue&type=script&lang=js"
export * from "./TabsD.vue?vue&type=script&lang=js"
import style0 from "./TabsD.vue?vue&type=style&index=0&id=be951680&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports